import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);
export function SiteContentProvider({ children }) {
  const [content, setContent] = useState({});
  const refresh = useCallback(async () => {
    try { const { data } = await api.get("/site-content"); setContent(data.data || {}); } catch {}
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  return <Ctx.Provider value={{ content, refresh }}>{children}</Ctx.Provider>;
}
export const useSiteContent = () => useContext(Ctx) || { content: {}, refresh: () => {} };
